'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { SkeletonBlock, SkeletonWrapper } from '../Skeleton';
import { KOALA } from 'HubStyleTokens/colors';
import { device } from '../../constants/StyledComponentConstants';
const ContentCardSkeletonWrapper = styled(UICardWrapper).withConfig({
  displayName: "ContentCardSkeleton__ContentCardSkeletonWrapper",
  componentId: "sc-10h3db-0"
})(["height:326px;border-radius:3px;@media screen and ", "{&:not(:last-child){margin-right:32px;}}"], device.mobile);

const ContentCardSkeleton = () => /*#__PURE__*/_jsx(ContentCardSkeletonWrapper, {
  children: /*#__PURE__*/_jsxs(SkeletonWrapper, {
    children: [/*#__PURE__*/_jsx(SkeletonBlock, {
      className: "ribbon",
      style: {
        height: 10
      }
    }), /*#__PURE__*/_jsx("div", {
      className: "section-with-bottom-hr",
      style: {
        borderBottom: '#eaf0f6 solid 1px',
        height: 120
      },
      children: /*#__PURE__*/_jsx("div", {
        style: {
          padding: '0 10px'
        },
        children: /*#__PURE__*/_jsxs(UIFlex, {
          justify: "between",
          children: [/*#__PURE__*/_jsxs(UIFlex, {
            direction: "column",
            children: [/*#__PURE__*/_jsx(SkeletonBlock, {
              className: "category",
              style: {
                height: 16,
                width: '40%',
                marginTop: 10
              }
            }), /*#__PURE__*/_jsx(SkeletonBlock, {
              className: "title",
              style: {
                height: 20,
                width: '90%',
                marginTop: 12
              }
            }), /*#__PURE__*/_jsx(SkeletonBlock, {
              className: "title",
              style: {
                height: 20,
                width: '75%',
                marginTop: 12
              }
            })]
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            className: "icon",
            style: {
              height: 50,
              width: 50,
              borderBottomLeftRadius: 50,
              borderBottomRightRadius: 50
            }
          })]
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "section",
      style: {
        height: 150
      },
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          padding: '0 10px'
        },
        children: [/*#__PURE__*/_jsx(SkeletonBlock, {
          className: "course-type",
          style: {
            height: 20,
            width: '25%',
            marginTop: 12
          }
        }), /*#__PURE__*/_jsx(SkeletonBlock, {
          className: "description-line",
          style: {
            height: 14,
            width: '95%',
            marginTop: 24
          }
        }), /*#__PURE__*/_jsx(SkeletonBlock, {
          className: "description-line",
          style: {
            height: 14,
            width: '98%',
            marginTop: 12
          }
        }), /*#__PURE__*/_jsx(SkeletonBlock, {
          className: "description-line",
          style: {
            height: 14,
            width: '80%',
            marginTop: 12
          }
        }), /*#__PURE__*/_jsx(SkeletonBlock, {
          className: "description-line",
          style: {
            height: 14,
            width: '82%',
            marginTop: 12
          }
        })]
      })
    }), /*#__PURE__*/_jsx(UIFlex, {
      justify: "end",
      style: {
        padding: '8px 10px'
      },
      children: /*#__PURE__*/_jsx(UIIcon, {
        color: KOALA,
        name: "socialHeart",
        size: 28
      })
    })]
  })
});

export default ContentCardSkeleton;